import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import './index.css';
import img1 from '../../../src/images/left-white.svg';
import img2 from '../../../src/images/7-days-icon.svg';
import img6 from '../../../src/images/red-icon.svg';
import img7 from '../../../src/images/green-icon.svg';
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, BarChart, Bar } from 'recharts';
import config from '../../config/config';

function InsulinUsage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { patientName, patientAge, patientCondition, patientId } = location.state || {};

    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [insulinData, setInsulinData] = useState([]);
    const [insulinVsGlucoseData, setInsulinVsGlucoseData] = useState([]);
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRange, setSelectedRange] = useState(7); // Default range is 7 days
    const [weeklyData, setWeeklyData] = useState(null);
    const [error, setError] = useState(null);
    const backendURL = `${config.backendServerHost}`;


    // Fetch patients list
  useEffect(() => {
    fetch(`${backendURL}/patients/api/patients`)
        .then((res) => res.json())
        .then((data) => {
            setPatients(data); // Store all patients
            const foundPatient = data.find(patient => patient.name === patientName); // Find patient by name
            if (foundPatient) {
                setSelectedPatient(foundPatient); // Set the selected patient
            } else {
                console.error(`Patient with name "${patientName}" not found.`);
            }
        })
        .catch((error) => console.error('Error fetching patients:', error));
}, [backendURL, patientName]);

const InsulinBarGraph = ({ patientId }) => {
    const [insulinData, setInsulinData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
    if (!selectedPatient || !selectedPatient.id) return;

        setLoading(true);
 fetch(`${backendURL}/patients/api/insulin-weekly-breakdown/${selectedPatient.id}?range=${selectedRange}`)            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch insulin data');
                }
                return res.json();
            })
            .then((data) => {
                // Sort data by date in ascending order
                const sortedData = data.sort((a, b) => new Date(a.day) - new Date(b.day));
                setInsulinData(sortedData);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [selectedPatient, selectedRange]);

    if (loading) return <div>Loading insulin data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!insulinData || insulinData.length === 0) return <div>No insulin data available</div>;

    // Derive the start date from the data
    const startDate = insulinData.length > 0 ? insulinData[0].day : '';

    // Format X-Axis ticks as month/day
    const formatXAxis = (tick) => tick;

    return (
        <div className="insulin-bar-graph">
            <div className="chart-container">
            <h2>Weekly Insulin Breakdown</h2>
            <p>Data starting from: {startDate}</p>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={insulinData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="day" // Ensure this field matches the `day` field in the API response
                            tickFormatter={formatXAxis}
                        />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="basal" fill="#FFD700" name="Basal Insulin" />
                        <Bar dataKey="bolus" fill="#7B68EE" name="Bolus Insulin" />
                    </BarChart>
                </ResponsiveContainer>


             {/* Bar Chart Details */}
                {weeklyData && weeklyData.weeklyTotals ? (
                <div className="bar-chart-details">
                    <div className="basal">
                        <h2>{weeklyData.weeklyTotals.basal}  units</h2>
                        <p>Basal Total</p>
                    </div>
                    <div className="bolus">
                        <h2>{weeklyData.weeklyTotals.bolus}units</h2>
                        <p>Bolus total</p>
                     </div>
                  </div>
                ) : (
                    <div>Loading weekly totals...</div>
                )}   
             </div>      
        </div>
    );
};


const WeeklyInsulinTotals = ({ patientId }) => {
    const [weeklyData, setWeeklyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientId) return;

        setLoading(true);
        fetch(`${backendURL}/patients/api/weekly-insulin-totals/${patientId}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch data');
                }
                return res.json();
            })
            .then((data) => {
                setWeeklyData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [patientId]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            <h2>Weekly Insulin Totals</h2>
            <p><strong>Basal Total:</strong> {weeklyData.weeklyTotals.basal} units</p>
            <p><strong>Bolus Total:</strong> {weeklyData.weeklyTotals.bolus} units</p>
        </div>
    );
};

const InsulinVsGlucoseGraph = ({ patientId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientId) return;

        setLoading(true);
        fetch(`${backendURL}/patients/api/insulin-vs-glucose/${patientId}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch Insulin vs Glucose data');
                }
                return res.json();
            })
            .then((response) => {
                // Ensure data is sorted by date and get the last 7 days
                const sortedData = response
                    .sort((a, b) => new Date(a.day) - new Date(b.day))
                    .slice(-7);

                setData(sortedData);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [patientId]);

    if (loading) return <div>Loading Insulin vs Glucose Data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data || data.length === 0) return <div>No data available</div>;

    return (
        <div className="insulin-vs-glucose">
            <h2>Insulin vs Glucose Trends</h2>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="day"
                        tickFormatter={(tick) => tick} // Assuming `day` is already formatted as `month/day`
                    />
                    <YAxis
                        yAxisId="left"
                        label={{ value: 'Insulin (units)', angle: -90, position: 'insideLeft' }}
                        domain={[0, 70]}
                    />
                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={{ value: 'Glucose (mg/dL)', angle: -90, position: 'insideRight' }}
                        domain={[0, 180]}
                    />
                    <Tooltip />
                    <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="insulin"
                        stroke="#82ca9d"
                        name="Daily Insulin Intake"
                    />
                    <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="glucose"
                        stroke="#8884d8"
                        name="Daily Average Glucose"
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};




    // Fetch patient-specific data when a patient is selected
    useEffect(() => {
        if (!selectedPatient || !selectedPatient.id) return;

        setLoading(true);

        // Fetch insulin vs glucose trends data
        fetch(`${backendURL}/patients/api/insulin-weekly-breakdown/${selectedPatient.id}`)
            .then((res) => res.json())
            .then((data) => {
                setInsulinVsGlucoseData(data || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching insulin vs glucose data:', err);
                setLoading(false);
            });
    }, [selectedPatient]);

    const handleRangeChange = (event) => {
        setSelectedRange(parseInt(event.target.value, 10));
    };

    const calculateDateRange = () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - selectedRange);
        const options = { month: 'short', day: 'numeric' };

        return `${startDate.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`;
    };

    useEffect(() => {
        if (!selectedPatient || !selectedPatient.id) return;

        setLoading(true);
        fetch(`${backendURL}/patients/api/weekly-insulin-totals/${selectedPatient.id}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch data');
                }
                return res.json();
            })
            .then((data) => {
                setWeeklyData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [selectedPatient]);

        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error: {error}</div>;

    const navigateTo = (path, state = {}) => {
    navigate(path, { state });
    };

    return (
        <div className="glucose-main-cantainer">
            <div className='glucose_container2'>

            <div className='glucose-navbar'>
                <div onClick={() => 
                    navigateTo('/patientinfo', {
                        state: { 
                            patientName: selectedPatient.name,
                            patientAge: selectedPatient.age,
                            patientCondition: selectedPatient.type,
                        },
                    })
                }>
                    <img src={img1} alt="Back to Patient Info" />
                </div>
                <div><h4>Insulin Breakdown</h4></div>
                <div></div>
            </div>

                <div className='days-button'><span><img src={img2} alt="" />
                </span>
                {/* Date Range */}
                <div className="header">
                    <select onChange={handleRangeChange} value={selectedRange}>
                       <option value={7}>7 Days</option>
                        <option value={14}>14 Days</option>
                        <option value={30}>30 Days</option>
                     </select>
                </div>
            </div>
                <div className='date-heading'><h5>{calculateDateRange()}</h5></div>
                <div className='charts-image'>
                <InsulinBarGraph patientId={selectedPatient.id} />         
                </div>
        </div>

            <div className='glucose-wrapper'>

                <div className='insulin-chart-image'>

            {selectedPatient &&(
                <>

                <InsulinVsGlucoseGraph patientId={selectedPatient.id} />
                </>
            )}
                </div>



                <div className='key-insights-text'>
                    <h2>Key Insights & Recommendations</h2>
                    <div className='recommendation-text'>
                        <div >
                            <h3>Nov 10 15:30</h3>
                            <h4>Bolus: Post-lunch glucose spike</h4>
                        </div>
                        <div>
                            <h5>-1<span>units</span><span><img src={img6} alt="" /></span></h5>
                        </div>
                    </div>
                    <div className='recommendation-text'>
                        <div >
                            <h3>Nov 9 09:35</h3>
                            <h4>Basal: Morning hypoglycemia trend</h4>
                        </div>
                        <div>
                            <h5>+2<span>units</span><span><img src={img7} alt="" /></span></h5>
                        </div>
                    </div>
                    <div className='recommendation-text'>
                        <div >
                            <h3>Nov 8 18:38</h3>
                            <h4>Bolus: Dinner carb ratio adjustment</h4>
                        </div>
                        <div>
                            <h5>+2<span>units</span><span><img src={img7} alt="" /></span></h5>
                        </div>
                    </div>
                    <div className='recommendation-text'>
                        <div >
                            <h3>Nov 7 06:30</h3>
                            <h4>Bolus: Post-breakfast glucose spike</h4>
                        </div>
                        <div>
                            <h5>-1<span>units</span><span><img src={img6} alt="" /></span></h5>
                        </div>
                    </div>
                    <div className='recommendation-text'>
                        <div >
                            <h3>Nov 7 15:30</h3>
                            <h4>Bolus: Post-lunch glucose spike</h4>
                        </div>
                        <div>
                            <h5>-1<span>units</span><span><img src={img6} alt="" /></span></h5>
                        </div>
                    </div>
                </div>
            </div>

        <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img12} alt="" />
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default InsulinUsage;
